import React from 'react';

const DEFAULT_DELAY_MS = 500;

export const useDelayedLoading = ({
  isLoading,
  delayMs = DEFAULT_DELAY_MS,
}: {
  isLoading: boolean;
  delayMs?: number;
}) => {
  const [showDelayedIndicator, setShowDelayedIndicator] = React.useState(false);

  React.useEffect(() => {
    if (!isLoading) {
      setShowDelayedIndicator(false);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setShowDelayedIndicator(true);
    }, delayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, isLoading]);

  return showDelayedIndicator;
};
